import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DestinationGroupingParentsIconImport from "../../misc/DestinationGroupingParentsIconImport";
import MaterialModal from "../MaterialModal";
import Alert from "@material-ui/lab/Alert";
import { hideModal } from "../../../actions/actionCreators";
import withModal from "../withModal";
import { IDestinationGroupingParents } from "../../../types/stores/destinationGroupingParents";
import { ISubDestination } from "../../../types/stores/vars";

import {
    GetDestinationGroupingParents,
    AddEditDestinationGroupingParent,
} from "../../../actions/destinationGroupingParentsActions";
import h from "../../../helpers";
import { IAppState } from "../../../types/stores/index";

interface AddEditDestinationGroupingParentsModalProps {
    isOpen: boolean;
    modalProps: {
        parentId: number;
        parentName: string;
        parentDesc: string;
        parentIcon: string;
        SubDestinations: Array<ISubDestination>;
    };
}

const DestinationGroupingParentsModal: React.FC<AddEditDestinationGroupingParentsModalProps> = ({
    isOpen,
    modalProps,
}: AddEditDestinationGroupingParentsModalProps) => {
    const dispatch = useDispatch();
    const [haveChanges, setHaveChanges] = useState(false);
    const [localDestinationGroupingParent, setLocalDestinationGroupingParent] = useState<IDestinationGroupingParents>();
    const [errorMessage, setErrorMessage] = useState("");

    const isSaving = useSelector<IAppState, boolean>(state => state.destinationGroupingParents.isSaving);
    const dgParents = useSelector<IAppState, Array<IDestinationGroupingParents>>(
        state => state.destinationGroupingParents.destinationGroupingParents
    );

    const handleDestinationGroupingParent = (data: IDestinationGroupingParents) => {
        setErrorMessage("");
        setLocalDestinationGroupingParent(data);
    };

    const hide = () => {
        setErrorMessage("");
        const initialState: IDestinationGroupingParents = {
            DestinationGroupingParentID: -1,
            ParentName: modalProps.parentName,
            ParentIcon: modalProps.parentIcon,
            Description: modalProps.parentDesc,
            SubDestinations: modalProps.SubDestinations || [],
        };
        setLocalDestinationGroupingParent(initialState);
        dispatch(hideModal("BROWSE_DESTINATIONGROUPING_PARENT_MODAL"));
    };

    const validate = () => {
        let validateErrors = "";
        const dup = dgParents.filter(
            x =>
                x.DestinationGroupingParentID != localDestinationGroupingParent?.DestinationGroupingParentID &&
                x.ParentName == localDestinationGroupingParent?.ParentName
        );
        if (dup && dup.length > 0) {
            validateErrors = "Destination Group Name must be unique!!!";
        }

        setErrorMessage(validateErrors);
        return validateErrors == "";
    };

    const AddEditDestinationGroupingParents = async () => {
        if (!localDestinationGroupingParent || isSaving) return;
        if (!validate()) {
            return;
        }
        try {
            const res = await dispatch(AddEditDestinationGroupingParent(localDestinationGroupingParent!));

            if (res) {
                setErrorMessage(res);
                return;
            }

            dispatch(GetDestinationGroupingParents());

            hide();
        } catch (err) {
            h.error("Unexpected error occurred.", err);
        }
    };

    return (
        <MaterialModal
            id="import-parent-icon"
            title={modalProps.parentId ? `Edit Destination Group` : `Add Destination Group`}
            maxWidth="lg"
            fullWidth={true}
            isOpen={Boolean(isOpen)}
            onClose={hide}
            cancelButtonText="Close"
            showPrimaryButton={true}
            primaryButtonText={modalProps.parentId ? `Save` : `Add`}
            onPrimaryButtonRequest={AddEditDestinationGroupingParents}
            isPrimaryButtonDisabled={!haveChanges}
        >
            <div>
                {errorMessage && (
                    <Alert severity="error" style={{ marginTop: "15px" }}>
                        {errorMessage}
                    </Alert>
                )}
                <DestinationGroupingParentsIconImport
                    handleHaveChanges={setHaveChanges}
                    onChangeParent={handleDestinationGroupingParent}
                    modalProps={modalProps}
                    parentId={modalProps.parentId ? modalProps.parentId : -1}
                />
            </div>
        </MaterialModal>
    );
};
export default withModal(DestinationGroupingParentsModal, "BROWSE_DESTINATIONGROUPING_PARENT_MODAL");
